module.exports = __webpack_public_path__ + "media/images/icons/tik-tok-5752bb5f77fd9da18dbc0a5c892e7557.svg";